import React from 'react';

const rowCenterSpcBtw = (): React.CSSProperties => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };
};

export default rowCenterSpcBtw;
